'use client'

import { forwardRef, useState } from 'react'

import { cn } from '@/lib/css-utils'

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  maxLength?: number
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { className, maxLength = 500, onChange, onFocus, onBlur, ...props },
    ref,
  ) => {
    const [isFocused, setIsFocused] = useState(false)
    return (
      <div className="relative pb-4">
        <textarea
          className={cn(
            'flex min-h-[60px] w-full text-input-text rounded-lg border border-input-border \
           bg-input-bg px-3 py-2 text-md transition \
          hover:border-input-hover-border placeholder:text-input-placeholder \
          focus-visible:outline focus-visible:outline-input-focus-border \
          disabled:cursor-not-allowed disabled:bg-input-disabled-bg disabled:border-input-disabled-border',
          'focus:outline-1 focus:outline-input-focus-border',
            className,
          )}
          onFocus={(e) => {
            setIsFocused(true)
            onFocus?.(e)
          }}
          onBlur={(e) => {
            setIsFocused(false)
            onBlur?.(e)
          }}
          ref={ref}
          onChange={(e) => {
            const newInput = e.target.value
            if (
              maxLength &&
              newInput.length > (props.value as string)?.length &&
              newInput.length > maxLength
            )
              return
            onChange?.(e)
          }}
          {...props}
        />
        {maxLength && isFocused ? (
          <div className="text-xs text-copy-accent text-right absolute bottom-[-2] right-0">
            <span className="sr-only">Character count:</span>
            <span aria-live="polite">
              {(props.value as string)?.length ?? 0}
            </span>{' '}
            / {maxLength}
          </div>
        ) : null}
      </div>
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
